import { Key, SetStateAction, useContext, useEffect, useState } from "react";
import { CardBody } from "../../Components/CardBody";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { io } from "socket.io-client";
import { MenuLeft } from "../../Components/MenuLeft";
import { InputField } from "../../Components/InputField";
import axios from "axios";
import { Practitioner } from "../Practitioner";



interface CalledData {
  idTbPanel: any;
  namePatient: string;
  namePractitioner: string;
  room: string;
  floor: string;
  lastName: string;
  created_at: string;
  quarto:string;
}

export const Called = () => {
  const globalContext = useContext(AuthContext);
  const [token] = useState<string | null>(localStorage.getItem("authToken"));
  const [called, setCalled] = useState<CalledData[]>([]);
  const [mensagem, setMensagem] = useState<String>("");
  const [sector, setSector] = useState([]);
  const [floor, setFloor] = useState<String>("");

  useEffect(()=>{
    axios.get(
      `https://painel-api.medc.com.br/practitionerAll/${globalContext.user?.organization}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    ).then(practitioner => {
      const data = practitioner.data;
      setSector(data);
      if (data.length > 0 && !floor) {
        setFloor(data[0].floor);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalContext.user?.organization]);

  
  useEffect(() => {
    const socket = io(`https://painel-socket.medc.com.br`, {
      autoConnect: true,
    });
    /*
    const socket = io(`http://localhost:3008`, {
      autoConnect: true,
    });*/

    socket.on("connect_error", (error) => {
      console.error("Connection Error:", error);
      setTimeout(() => {
        socket.connect();
      }, 1000);
    });

    socket.on("connect", () => {
      //console.log("Connected to WebSocket server");
      socket.emit("boasvindas", {
        id: globalContext.user?.organization,
      });
    });

    socket.on("getCalled", (data) => {
      //console.log("Received data from WebSocket:", data);
      const section = data.filter((called: { floor: string; }) => called.floor === floor);
      setCalled(section);
      if (data.length === 0) {
        setMensagem("Não existe chamado");
      } else {
        setMensagem("ÚLTIMAS CHAMADAS");
      }
    });

    return () => {
      if (socket.active) {
        socket.close();
      }
    };
  }, [floor]);

  return (
    <>
      <MenuLeft />
      <div style={{ flex: 9, margin: 40 }}>
        <div className="row">
          <div className="col-12">

            <InputField item={sector} onChange={(value: string) => setFloor(`${value}`)} />
            <div
              className="list disable-text-selection current-called"
              data-check-all="checkAll"
              style={{ marginBottom: 100 }}
            >
              {called.length === 0 &&
                <div className="mb-2">
                  <h1>Nenhum paciente chamado</h1>
                </div>
              }
              {called.length > 0 &&
                <>
                  <div className="mb-2">
                    <h1>Último Chamado:</h1>
                  </div>
                  <CardBody
                    name={called[0].namePatient}
                    lastName={called[0].namePatient}
                    practitioner={called[0].namePractitioner}
                    room={called[0].room}
                    floor={called[0].floor}
                    link={""}
                    speach={called[0].namePatient} 
                    quarto = {`Sala: ${called[0].room}`}                   
                    color={"powderblue"}
                    created={called[0].created_at}
                  />
                </>
              }
            </div>
            <>
              {called.length > 1 && (
                <><h1>
                  Chamados Anteriores:
                </h1>
                  <div className="list disable-text-selection" data-check-all="checkAll">
                    {
                      called.filter((_, index) => index !== 0).map((response, index: Key) => {
                        const lastWord = called[0].namePatient;

                        return (
                          <CardBody
                            key={index}
                            name={response.namePatient}
                            lastName={lastWord}
                            practitioner={response.namePractitioner}
                            room={response.room}
                            floor={response.floor}
                            link={""}
                            speach={""}
                            quarto={""}
                            color={""}
                            created={response.created_at}
                          />
                        );
                      })}
                  </div></>)}
            </>
          </div>
        </div>
      </div>
      <footer className="page-footer" style={{ paddingRight: 50, bottom: 0, position: 'fixed', height: 22, borderWidth: 0 }}>
        <div className="float-right">
          <p className="mb-0 text-muted">Cadclin @2024</p>
        </div>
      </footer>
    </>
  );
};
